import { ApolloQueryResult, gql } from "@apollo/client";
import { put } from "redux-saga/effects";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { OAuthClient } from "~/EasyProjectsCommon/OAuthClient";
import { Space } from "~/Redux/Spaces";
import { updateSpaces } from "~/Redux/Spaces/state/spacesSlice";

interface SpaceResponse {
    spaces: Space[];
}

export function* loadSpaces() {
    const { data }: ApolloQueryResult<SpaceResponse> = yield getSpaces();
    yield put(updateSpaces(data.spaces, { overrideAll: true }));
}

const getSpaces = () => {
    return OAuthClient.graphql<SpaceResponse>(appUrls.spaces.graphql, {
        query: gql`
            query {
                spaces {
                    SpaceId: spaceId
                    Name: name
                    Color: color
                    Icon: icon
                    CanEdit: canEdit
                    CanCreateProjects: canCreateProjects
                    CanInviteUsers: canInviteUsers
                }
            }
        `,
    });
};
